module.exports = __webpack_public_path__ + "img/works_ibk_btm.341bec01.png";